import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowRight, Car, ClipboardCheck, Zap } from "lucide-react";
const services = [{
  title: "Produção de Vídeo",
  description: "Vídeos estratégicos e cinematográficos desenvolvidos para fortalecer sua marca e converter leads em clientes reais.",
  icon: Zap,
  url: "https://itcmais.com/produtora-de-video-em-sao-paulo"
}, {
  title: "Estúdio de Podcast",
  description: "Gravação profissional em Pinheiros com infraestrutura completa para gerar autoridade e conexão com seu público.",
  icon: Car,
  url: "https://itcmais.com/estudio-de-podcast-em-pinheiros"
}, {
  title: "Tráfego Pago",
  description: "Gestão de anúncios com foco total em aquisição de clientes e ROI, posicionando sua empresa no topo das buscas.",
  icon: ClipboardCheck,
  url: "https://itcmais.com/trafego-pago-para-empresas-que-querem-gerar-clientes"
}];
export default function ServicesNavigationGrid() {
  return <section data-section-id="242096" id="whatweproduce" className="bg-background text-foreground">
      <div className="bg-background py-16 md:py-24">
        <div className="container mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {services.map((service, i) => {
            const Icon = service.icon;
            return <Card key={i} data-index={i} className="bg-card backdrop-blur-none border-border hover:border-primary/50 transition-all duration-300 rounded-2xl overflow-hidden group shadow-sm hover:shadow-md">
                  <CardContent className="p-8 flex flex-col h-full">
                    <div className="mb-6 inline-flex p-3 rounded-xl bg-primary/5 text-primary group-hover:bg-primary/10 transition-colors">
                      <Icon className="w-8 h-8" strokeWidth={1.5} />
                    </div>
                    
                    <h3 className="font-default text-xl font-bold text-foreground mb-3 tracking-tight">
                      {service.title}
                    </h3>
                    
                    <p className="font-sans text-muted-foreground mb-8 leading-relaxed flex-grow text-sm">
                      {service.description}
                    </p>
                    
                    <div className="mt-auto">
                      <Link to={service.url} className="inline-flex items-center text-primary font-semibold hover:text-primary/80 transition-colors text-sm group/link">
                        Saiba Mais
                        <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover/link:translate-x-1" />
                      </Link>
                    </div>
                  </CardContent>
                </Card>;
          })}
          </div>
        </div>
      </div>
    </section>;
}